<template>
  <div>
    <NavBar msg="笔记内容"></NavBar>
    <div class="time">
      <span>{{ info.ctime.substr(0, info.ctime.length - 3) }}</span>
      <div @click="removeClick()">
        <img src="../assets/ic_qingchulishi@2x.png" alt="" />
      </div>
    </div>
    <div class="content">{{ info.text }}</div>
  </div>
</template>
<script>
import { getUrlParams } from "@/utils/utility";
import NavBar from "@/components/NavBar.vue";
import api from "@/api/index";
import { Toast } from "vant";
export default {
  components: { NavBar, [Toast.name]: Toast },

  data() {
    return {
      info: "",
    };
  },
  created() {
    this.info = JSON.parse(sessionStorage.getItem("item"));
    // console.log(this.info);
  },
  methods: {
    removeClick() {
      api.getDeleteNote({ noteId: this.info.id }).then((res) => {
        if (res.code == 200) {
          Toast("删除成功");
          this.$router.go(-1);
        } else {
          Toast(res.message);
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.time {
  margin-top: 0.88rem;
  padding: 0 0.32rem;
  height: 0.96rem;
  background: #f5f5f5;
  display: flex;
  justify-content: space-between;
  align-items: center;
  div {
    width: 1rem;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 0.32rem;
    }
  }
}
.content {
  padding: 0.32rem;
  font-size: 0.32rem;
  font-weight: 400;
  color: #333333;
  background: #fff;
  line-height: 0.48rem;
}
</style>